export default __webpack_public_path__ + "static/media/mdn.793c6baf.webp";